<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconStar_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="m21.676 8.943-6.114-.888-2.734-5.54a.923.923 0 0 0-1.655 0l-2.734 5.54-6.115.888a.923.923 0 0 0-.511 1.574l4.424 4.313-1.044 6.09a.923.923 0 0 0 1.339.973L12 19.017l5.469 2.875a.923.923 0 0 0 1.339-.973l-1.044-6.09 4.424-4.313a.922.922 0 0 0-.512-1.573Z"
    />
</svg>
